import { render, staticRenderFns } from "./PacienteTitulo.vue?vue&type=template&id=62493d20&"
import script from "./PacienteTitulo.vue?vue&type=script&lang=js&"
export * from "./PacienteTitulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports